export default __webpack_public_path__ + "static/media/portfolio-122.be2e8f08.jpg";